const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBProgressPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-progress-pending",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconB-progress-pending1",
    serifid: "iconB-progress-pending"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1c6.071,0 11,4.929 11,11c0,6.071 -4.929,11 -11,11c-6.071,0 -11,-4.929 -11,-11c0,-6.071 4.929,-11 11,-11Zm0,1.986c-4.975,0 -9.014,4.039 -9.014,9.014c0,4.975 4.039,9.014 9.014,9.014c4.975,-0 9.014,-4.039 9.014,-9.014c-0,-4.975 -4.039,-9.014 -9.014,-9.014Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.771,2.036c-0,-0.01 -0,-0.02 -0,-0.031c0,-0.287 0.102,-0.554 0.287,-0.725c0.179,-0.166 0.474,-0.275 0.715,-0.261l0.002,-0c3.351,0.241 6.362,1.975 8.291,4.72c0.001,0.001 0.002,0.002 0.002,0.003c0.156,0.232 0.209,0.519 0.146,0.792c-0.062,0.272 -0.234,0.506 -0.475,0.647l-0.009,0.005c-0.447,0.273 -1.044,0.122 -1.338,-0.313c-1.569,-2.228 -4.055,-3.643 -6.776,-3.844c-0.471,-0.029 -0.845,-0.496 -0.845,-0.967c-0,-0.009 -0,-0.018 0,-0.026Zm-3.971,10.366c0.165,-0.195 0.431,-0.293 0.707,-0.293c0.276,-0 0.526,0.112 0.707,0.292l1.786,1.786l-0,-6.788c-0,-0.553 0.448,-1 1,-1c0.552,-0 1,0.447 1,1l-0,6.788l1.786,-1.786c0.181,-0.181 0.431,-0.292 0.707,-0.292c0.552,-0 1,0.447 1,1c-0,0.276 -0.112,0.526 -0.293,0.707l-3.493,3.493c-0.181,0.181 -0.431,0.292 -0.707,0.292c-0.276,0 -0.526,-0.111 -0.707,-0.292l-3.493,-3.493c-0.181,-0.181 -0.293,-0.431 -0.293,-0.707c0,-0.275 0.119,-0.502 0.293,-0.707Z",
    style: {
      fill: "#f80"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBProgressPending);
export default __webpack_public_path__ + "static/media/iconB-progress-pending.3d6beef614c7558efcc2012e699ea578.svg";
export { ForwardRef as ReactComponent };